<template>
  <v-btn
    icon
    variant="text"
    class="mr-5"
    :disabled="isDisabled"
    @click="onTuneDialog"
  >
    <v-icon>tune</v-icon>
    <v-tooltip activator="parent" location="bottom">
      Manage Parameters
    </v-tooltip>
  </v-btn>
  <v-dialog v-model="isTuneDialogOpen" persistent width="80vw">
    <v-card class="pa-5">
      <v-card-title class="text-h5">
        <v-row class="align-center">
          Manage Parameters
          <v-btn
            icon
            class="ml-10"
            variant="text"
            :disabled="isDisabled"
            @click="loadData"
          >
            <v-icon>refresh</v-icon>
            <v-tooltip
              activator="parent"
              location="right"
              :disabled="isDisabled"
            >
              Reload all parameter
            </v-tooltip>
          </v-btn>

          <v-spacer />
          <v-label>{{ showDataFileTitle }}</v-label>
          <v-btn
            variant="text"
            :loading="loadingBtnOpen"
            @click="onButtonClickOpen"
          >
            <v-icon>folder_open</v-icon>
            <v-tooltip activator="parent" location="bottom">
              Open from file
            </v-tooltip>
          </v-btn>
          <input
            ref="openFile"
            :key="openFileKey"
            class="d-none"
            type="file"
            accept=".param"
            @change="onFileOpenChanged"
          />
          <v-dialog v-model="saveDialog" persistent width="auto">
            <template #activator="{ props }">
              <v-btn
                v-bind="props"
                variant="text"
                :loading="loadingBtnSave"
                :disabled="isSaveButtonDisabled"
                @click="onButtonClickSave"
              >
                <v-icon>save</v-icon>
                <v-tooltip activator="parent" location="bottom">
                  Save to file
                </v-tooltip>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="text-h5"> Download Chart Data </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="saveFileBaseName"
                  :rules="[(v: unknown) => !!v || 'Field is required']"
                  label="File name"
                  variant="underlined"
                  suffix=".param"
                  :error-messages="saveFileErrorMessage"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="green-darken-1"
                  variant="text"
                  @click="downloadSaveData"
                >
                  Download
                </v-btn>
                <v-btn
                  color="green-darken-1"
                  variant="text"
                  @click="
                    () => {
                      loadingBtnSave = false;
                      saveDialog = false;
                    }
                  "
                >
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="showConfirmFactorySettingDialog"
            persistent
            width="auto"
          >
            <template #activator="{ props }">
              <v-btn
                v-bind="props"
                variant="text"
                :disabled="modbusStore.accessLevel < AccessLevel.full"
              >
                <v-icon>manage_history</v-icon>
                <v-tooltip activator="parent" location="bottom">
                  Factory parameters
                </v-tooltip>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="text-h5">Confirm Dialog</v-card-title>
              <v-card-text>
                Are you sure you want to reset all parameters to factory
                settings?
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="green-darken-1"
                  variant="text"
                  @click="loadFactorySettings"
                >
                  Ok
                </v-btn>
                <v-btn
                  color="green-darken-1"
                  variant="text"
                  @click="closeConfirmFactorySettingDialog"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn variant="text" @click="isTuneDialogOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row class="mr-5 ml-5">
          <v-label>{{ loadingLabel }}</v-label>
          <v-spacer />
          <v-label>
            {{ checkedConfigItemsLength }} / {{ configItemsLength }}
          </v-label>
          <v-progress-linear
            :model-value="progressValue"
            :color="loadingColor"
            buffer-value="0"
            stream
          />
        </v-row>
        <v-row>
          <v-spacer />
          <v-radio-group v-model="radioSelection" inline>
            <v-radio label="All: " value="all" class="ml-5"></v-radio>
            <v-radio :label="defaultLabel" value="default" class="ml-5" />
            <v-radio
              :label="nonDefaultLabel"
              value="non-default"
              class="ml-5"
            />
            <v-radio :label="errorLabel" value="error" class="ml-5"></v-radio>
          </v-radio-group>
        </v-row>
        <v-row class="pr-5 pl-5 mt-0">
          <v-col cols="1">No</v-col>
          <v-col cols="2">Group/Subgroup</v-col>
          <v-col cols="3">Name</v-col>
          <v-col cols="2">Value</v-col>
          <v-col cols="2">Default</v-col>
          <v-col cols="2"></v-col>
        </v-row>
        <v-divider class="pb-5" />
        <v-list class="overflow-y-auto pa-5" max-height="400">
          <div
            v-for="item in configItems"
            :key="item['mbus address'] + '-list-item-div'"
          >
            <v-row
              v-if="show_enable[item['mbus address']]"
              :key="item['mbus address'] + '-list-item-row'"
              :class="classParamRow[item['mbus address']]"
            >
              <v-col cols="1">
                {{ configItemsIndex[item[ParamField.mbusAddress]] }}
              </v-col>
              <v-col cols="2">
                {{
                  item.group +
                  (item.sub_group == "0" ? "" : " / " + item.sub_group)
                }}
              </v-col>
              <v-col cols="3">{{ item.name }}</v-col>
              <v-col cols="2">
                {{
                  modbusStore.modbusAddrErrMsg[item[ParamField.mbusAddress]] ==
                  ""
                    ? modbusStore.modbusAddrValue[item[ParamField.mbusAddress]]
                    : modbusStore.modbusAddrErrMsg[item[ParamField.mbusAddress]]
                }}
              </v-col>
              <v-col cols="2">
                {{
                  modbusStore.modbusAddrDefaultValue[
                    item[ParamField.mbusAddress]
                  ]
                }}
              </v-col>
              <v-col cols="2">
                <v-btn
                  icon="refresh"
                  variant="text"
                  @click="reload(item['mbus address'])"
                />
                <v-btn icon variant="text">
                  <v-icon>info</v-icon>
                  <v-tooltip activator="parent" location="bottom">
                    mbus_address: {{ item[ParamField.mbusAddress] }}<br />
                    param_type: {{ item[ParamField.type] }}<br />
                    user_info: {{ item[ParamField.userInfo] }}
                  </v-tooltip>
                </v-btn>

                <v-menu :close-on-content-click="false">
                  <template #activator="{ props }">
                    <v-btn v-bind="props" icon="edit" variant="text" />
                  </template>
                  <v-card class="pa-5" width="600px">
                    <v-card-title class="text-h5">
                      <v-row class="align-center"> Edit Parameters </v-row>
                    </v-card-title>
                    <v-card-text class="mt-5">
                      <ConfigInput
                        show-buttons
                        :parameter="item"
                        :significance="5"
                        modbus-reload
                      />
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-col>
            </v-row>
          </div>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed, inject, ref, watch } from "vue";
import { useTheme } from "vuetify";
import { saveAs } from "file-saver";
import ConfigInput from "@/components/ConfigInput.vue";
import { useDelay } from "@/composables/useDelay";
import { useUtils } from "@/composables/useUtils";
import { AccessLevel } from "@/enums/AccessLevel";
import { ParamField } from "../enums/ParamField";
import { PortState } from "@/enums/PortState";
import { useModbusStore } from "@/stores/useModbusStore";
import { Dictionary } from "@/types/Dictionary";
import { Logger } from "@/types/Logger";
import { ModbusParam } from "@/types/ModbusParam";
import { TimerId } from "@/types/TimerId";

const $log = inject<Logger>("vuejs3-logger");

const { delay } = useDelay();
const modbusStore = useModbusStore();
const theme = useTheme();
const { valueToWriteArray } = useUtils($log);

const deviceDataTitle = "--- not saved ---";

const isTuneDialogOpen = ref(false);
const configItems = ref<ModbusParam[]>([]);
const configItemsLength = ref(0);
const classParamRow = ref<Dictionary<string>>({});
const show_enable = ref<Dictionary<boolean>>({});
const defaultLabel = ref("default : ");
const nonDefaultLabel = ref("non-default : ");
const errorLabel = ref("error : ");
const timeStateChange = ref<TimerId>(0);
const radioSelection = ref("all");
const loadingLabel = ref("Checked Parameters");
const saveFileBaseName = ref("");
const saveDialog = ref(false);
const saveFileErrorMessage = ref("");
const loadingBtnSave = ref(false);
const showDataFileTitle = ref(deviceDataTitle);
const showConfirmFactorySettingDialog = ref(false);
const openFile = ref();
const openFileKey = ref("open_file_" + new Date().getTime());
const openFileName = ref("");
const loadingBtnOpen = ref(false);

const progressValue = computed(() => {
  return (checkedConfigItemsLength.value / configItemsLength.value) * 100;
});

const loadingColor = computed(() => {
  return progressValue.value === 100
    ? "teal"
    : progressValue.value > 60
      ? "warning"
      : "error";
});

const isDisabled = computed<boolean>(() => {
  return modbusStore.portState === PortState.disconnected;
});

const configItemsIndex = computed<Dictionary<number>>(() => {
  let index = 0;
  const obj: Dictionary<number> = {};
  configItems.value.forEach((item) => {
    index++;
    obj[item[ParamField.mbusAddress]] = index;
  });
  return obj;
});

const checkedConfigItemsLength = computed<number>(() => {
  let cnt = 0;
  configItems.value.forEach((item) => {
    if (modbusStore.modbusAddrValue[item[ParamField.mbusAddress]] != null) {
      cnt++;
    }
  });
  return cnt;
});

const isSaveButtonDisabled = computed<boolean>(
  () =>
    showDataFileTitle.value !== deviceDataTitle ||
    checkedConfigItemsLength.value !== configItemsLength.value,
);

// ----- functions -----
async function onTuneDialog() {
  const params = modbusStore.writeableParams.filter(
    (item) =>
      item.name != null &&
      item.name != "0" &&
      modbusStore.isParamUserWriteable(item) &&
      (item.input_type === "checkbox" ||
        item.input_type === "dropdown" ||
        item.input_type === "switch" ||
        item.type == "int" ||
        item.type == "float" ||
        item.type == "uint16_t" ||
        item.type == "uint32_t" ||
        (item.type == "char2" && item.name.indexOf("[0:1]") > 0)),
  );
  configItems.value = params;
  configItemsLength.value = params.length;
  params.forEach((item) => {
    classParamRow.value[item[ParamField.mbusAddress]] =
      "align-center param-row-dark";
  });

  showDataFileTitle.value = deviceDataTitle;
  // loadingLabel.value = "Loading all current parameters ...";
  // loadingColor.value = "teal";
  loadingBtnOpen.value = false;
  loadingBtnSave.value = false;

  isTuneDialogOpen.value = true;

  loadData();
}

function clearModbusAddrValues() {
  modbusStore.modbusAddrValue = {};
  configItems.value.forEach((item) => {
    modbusStore.modbusAddrValue[item[ParamField.mbusAddress]] = null;
  });
}

async function loadData() {
  clearModbusAddrValues();

  showDataFileTitle.value = deviceDataTitle;

  Promise.all(
    configItems.value.map(async (item) => {
      const mbusAddress = parseInt(item[ParamField.mbusAddress]);
      modbusStore.modbusAddrReadBusy[mbusAddress] = true;
      for (let i = 0; i < modbusStore.maxReloadCount; i++) {
        modbusStore.modbusAddrReadBusy[mbusAddress] = true;
        modbusStore.modbusRead(
          modbusStore.deviceAddress,
          mbusAddress,
          modbusStore.modbusAddrLength[item[ParamField.mbusAddress]],
        );
        while (modbusStore.modbusAddrReadBusy[mbusAddress]) {
          await delay(1);
        }
        if (modbusStore.modbusAddrErrMsg[mbusAddress] == "") {
          break;
        }
      }
    }),
  );

  classParamRow.value = getClassRow();
}

async function reload(addr: string) {
  for (let i = 0; i < modbusStore.maxReloadCount; i++) {
    modbusStore.modbusAddrValue[addr] = null;
    modbusStore.modbusAddrReadBusy[parseInt(addr)] = true;
    modbusStore.modbusRead(
      modbusStore.deviceAddress,
      parseInt(addr),
      modbusStore.modbusAddrLength[addr],
    );
    while (modbusStore.modbusAddrReadBusy[addr]) {
      await delay(1);
    }
    if (modbusStore.modbusAddrErrMsg[addr] == "") {
      break;
    }
  }
}

function getClassRow() {
  const theme_class = theme.global.current.value.dark
    ? "align-center theme-dark param-row "
    : "align-center theme-light param-row";
  const obj: Dictionary<string> = {};
  const all_cnt = configItems.value.length;
  let non_default_cnt = 0;
  let default_cnt = 0;
  let error_cnt = 0;

  configItems.value.forEach((item) => {
    if (
      modbusStore.modbusAddrValue[item[ParamField.mbusAddress]] ===
      modbusStore.modbusAddrDefaultValue[item[ParamField.mbusAddress]]
    ) {
      obj[item[ParamField.mbusAddress]] = theme_class;
      default_cnt++;
    } else {
      obj[item[ParamField.mbusAddress]] =
        theme_class + " param-row-non-default";
    }
    if (modbusStore.modbusAddrErrMsg[item[ParamField.mbusAddress]] != "") {
      obj[item[ParamField.mbusAddress]] =
        obj[item[ParamField.mbusAddress]] + " param-row-error";
      error_cnt++;
    }
  });
  non_default_cnt = all_cnt - default_cnt - error_cnt;
  defaultLabel.value = "default : " + default_cnt.toString();
  nonDefaultLabel.value = "non-default : " + non_default_cnt.toString();
  errorLabel.value = "error : " + error_cnt.toString();

  return obj;
}

function getShowEnable() {
  const obj: Dictionary<boolean> = {};

  configItems.value.forEach((item) => {
    const isDefault: boolean =
      modbusStore.modbusAddrValue[item[ParamField.mbusAddress]] ===
      modbusStore.modbusAddrDefaultValue[item[ParamField.mbusAddress]];
    switch (radioSelection.value) {
      case "all":
        obj[item[ParamField.mbusAddress]] = true;
        break;
      case "default":
        obj[item[ParamField.mbusAddress]] = isDefault;
        break;
      case "non-default":
        obj[item[ParamField.mbusAddress]] = !isDefault;
        break;
      case "error":
        obj[item[ParamField.mbusAddress]] =
          modbusStore.modbusAddrErrMsg[item[ParamField.mbusAddress]] !== "";
        break;
      default:
        obj[item[ParamField.mbusAddress]] = false;
    }
  });
  return obj;
}

function onButtonClickOpen() {
  loadingBtnOpen.value = true;
  window.addEventListener(
    "focus",
    () => {
      loadingBtnOpen.value = false;
    },
    { once: true },
  );
  openFile.value.click();
}

async function loadSetting(
  mbusAddress: string,
  newValue: string | number | boolean,
) {
  if (newValue === modbusStore.modbusAddrValue[mbusAddress]) {
    return;
  }
  if (!modbusStore.isAddressUserWriteable(mbusAddress)) {
    $log?.debug(
      `TuneDialog::loadSetting: skipping modbus address ${mbusAddress}: ` +
        `not writeable at this access level (${modbusStore.accessLevel})`,
    );
    return;
  }
  modbusStore.modbusAddrValue[mbusAddress] = null;
  modbusStore.modbusAddrReadBusy[mbusAddress] = true;

  const writeValueArray: number[] = valueToWriteArray(
    newValue,
    modbusStore.modbusAddrParams[mbusAddress][ParamField.type],
    modbusStore.modbusAddrLength[mbusAddress],
  );

  for (let i = 0; i < modbusStore.maxReloadCount; i++) {
    modbusStore.modbusAddrWriteBusy[mbusAddress] = true;
    modbusStore.modbusWrite(
      modbusStore.deviceAddress,
      parseInt(mbusAddress),
      modbusStore.modbusAddrLength[mbusAddress],
      new Uint8Array(writeValueArray),
    );
    while (modbusStore.modbusAddrWriteBusy[mbusAddress]) {
      await delay(1);
    }
    if (modbusStore.modbusAddrErrMsg[mbusAddress] === "") {
      break;
    }
  }

  while (modbusStore.modbusAddrReadBusy[mbusAddress]) {
    await delay(1);
  }

  if (modbusStore.modbusAddrErrMsg[mbusAddress] !== "") {
    for (let j = 0; j < modbusStore.maxReloadCount; j++) {
      modbusStore.modbusAddrReadBusy[mbusAddress] = true;
      modbusStore.modbusRead(
        modbusStore.deviceAddress,
        parseInt(mbusAddress),
        modbusStore.modbusAddrLength[mbusAddress],
      );
      while (modbusStore.modbusAddrReadBusy[mbusAddress]) {
        await delay(1);
      }
      if (modbusStore.modbusAddrErrMsg[mbusAddress] === "") {
        break;
      }
    }
  }
}

function loadFileSettings(event: ProgressEvent<FileReader>) {
  const result = event.target?.result ?? "";
  const paramsInfo = JSON.parse(
    typeof result === "string" ? result : new TextDecoder().decode(result),
  );
  // loadingLabel.value = "Setting all parameters from file...";
  const modbusAddresses = Object.keys(paramsInfo).filter(
    (item) => item !== "accessLevel",
  );
  modbusAddresses.forEach((address) => {
    const newValue: unknown = paramsInfo[address];
    if (
      typeof newValue === "string" ||
      typeof newValue === "number" ||
      typeof newValue === "boolean"
    ) {
      loadSetting(address, newValue);
    }
  });
  openFileKey.value = "open_file_" + new Date().getTime();
  showDataFileTitle.value = openFileName.value;
}

function onFileOpenChanged(e: Event) {
  if (e.target instanceof HTMLInputElement && e.target.files?.[0]) {
    const reader = new FileReader();
    reader.addEventListener("load", loadFileSettings);
    reader.readAsText(e.target.files[0]);
    openFileName.value = e.target.files[0].name;
  }
}

function onButtonClickSave() {
  saveFileBaseName.value = "";
  saveFileErrorMessage.value = "";
  loadingBtnSave.value = true;
}

function downloadSaveData() {
  if (saveFileBaseName.value === "") {
    saveFileErrorMessage.value = "Field is required";
  } else {
    const paramsInfo: Dictionary<string | number | boolean | null> = {};
    configItems.value.forEach((item) => {
      paramsInfo[item[ParamField.mbusAddress]] =
        modbusStore.modbusAddrValue[item[ParamField.mbusAddress]];
    });
    const blob = new Blob([JSON.stringify(paramsInfo)], {
      type: "application/json",
    });
    const saveFileName = `${saveFileBaseName.value}.param`;
    saveAs.saveAs(blob, saveFileName);
    showDataFileTitle.value = saveFileName;
    saveDialog.value = false;
    loadingBtnSave.value = false;
    modbusStore.modbusIsChanged = false;
  }
}

function closeConfirmFactorySettingDialog() {
  showConfirmFactorySettingDialog.value = false;
}

function loadFactorySettings() {
  configItems.value.forEach((item) => {
    const address = item[ParamField.mbusAddress];
    loadSetting(address, modbusStore.modbusAddrDefaultValue[address]);
  });
  openFileKey.value = "open_file_" + new Date().getTime();
  showDataFileTitle.value = "--- factory setting ---";
  showConfirmFactorySettingDialog.value = false;
}

//----- watchers --------------------------------------
watch(radioSelection, () => {
  show_enable.value = getShowEnable();
});

watch(progressValue, () => {
  clearTimeout(timeStateChange.value);
  timeStateChange.value = setTimeout(() => {
    classParamRow.value = getClassRow();
    show_enable.value = getShowEnable();
  }, 500);
});

watch(
  () => modbusStore.modbusIsChanged,
  (newVal) => {
    if (newVal) {
      showDataFileTitle.value = deviceDataTitle;
      openFileKey.value = "open_file_" + new Date().getTime();
    }
  },
);
</script>

<style scoped lang="scss">
.param-row-non-default.theme-light {
  background: rgb(240, 240, 240);
}
.param-row-non-default.theme-dark {
  background: rgb(60, 60, 60);
}
.param-row.theme-light:hover {
  background: rgb(230, 230, 230);
}
.param-row.theme-dark:hover {
  background: rgb(20, 20, 20);
}
.param-row-error {
  color: rgb(200, 20, 20);
}
</style>
